const EVerkaufsumfang = [
    { key: "VERKAUF", en: "Sell", de: "Verkauf" },
    { key: "VERMIETUNG", en: "Rent", de: "Vermietung" }
];

export default EVerkaufsumfang;